import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

function EmptyState({
  title = "Aucun resultat",
  description = "Aucune donnee a afficher pour le moment.",
  icon: Icon = Inbox,
  className,
  action,
}) {
  return (
    <div className={cn("rounded-2xl border border-dashed border-emerald-300 bg-emerald-50 p-6 text-center", className)}>
      <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-white text-emerald-600">
        <Icon className="h-5 w-5" />
      </div>
      <p className="text-sm font-semibold text-emerald-900">{title}</p>
      <p className="mt-1 text-sm text-emerald-800">{description}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}

export { EmptyState };
